//Makes it safe to do console.log() always.
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

// Minified version of isMobile
!function(a){var b=/iPhone/i,c=/iPod/i,d=/iPad/i,e=/(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,f=/Android/i,g=/(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,h=/(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,i=/IEMobile/i,j=/(?=.*\bWindows\b)(?=.*\bARM\b)/i,k=/BlackBerry/i,l=/BB10/i,m=/Opera Mini/i,n=/(CriOS|Chrome)(?=.*\bMobile\b)/i,o=/(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,p=new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i"),q=function(a,b){return a.test(b)},r=function(a){var r=a||navigator.userAgent,s=r.split("[FBAN");return"undefined"!=typeof s[1]&&(r=s[0]),s=r.split("Twitter"),"undefined"!=typeof s[1]&&(r=s[0]),this.apple={phone:q(b,r),ipod:q(c,r),tablet:!q(b,r)&&q(d,r),device:q(b,r)||q(c,r)||q(d,r)},this.amazon={phone:q(g,r),tablet:!q(g,r)&&q(h,r),device:q(g,r)||q(h,r)},this.android={phone:q(g,r)||q(e,r),tablet:!q(g,r)&&!q(e,r)&&(q(h,r)||q(f,r)),device:q(g,r)||q(h,r)||q(e,r)||q(f,r)},this.windows={phone:q(i,r),tablet:q(j,r),device:q(i,r)||q(j,r)},this.other={blackberry:q(k,r),blackberry10:q(l,r),opera:q(m,r),firefox:q(o,r),chrome:q(n,r),device:q(k,r)||q(l,r)||q(m,r)||q(o,r)||q(n,r)},this.seven_inch=q(p,r),this.any=this.apple.device||this.android.device||this.windows.device||this.other.device||this.seven_inch,this.phone=this.apple.phone||this.android.phone||this.windows.phone,this.tablet=this.apple.tablet||this.android.tablet||this.windows.tablet,"undefined"==typeof window?this:void 0},s=function(){var a=new r;return a.Class=r,a};"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=r:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=s():"function"==typeof define&&define.amd?define("isMobile",[],a.isMobile=s()):a.isMobile=s()}(this);

var formatMoney = "$ \{\{amount\}\}";

jQuery(function($) {
    setTimeout(function(){
      
      if($('#header').height() == 0){
        $('.content-wrapper').css('padding-top', $('.header-internal').height());
        $(window).resize(function(){          
          $('.content-wrapper').css('padding-top', $('.header-internal').height());
        });
      }else{
        $('.content-wrapper').css('padding-top', $('#header').height());
        $(window).resize(function(){          
          $('.content-wrapper').css('padding-top', $('#header').height());
        });
      }
      
    }, 200);

  	if(!isMobile.any) {
      $('body').addClass('isNotMobile');
    }else{
      $('body').addClass('isMobile');
    }

  	$(document).on("click", ".quantity .minus", function() {
        var wrapper = $(this).parent();
      try {
          wrapper.find('input[type=number]').get(0).stepDown();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())-1);
          wrapper.find('input[type=number]').val((value>=0 ? value : 0));
          wrapper.find('input[type=number]').change();
        }
    });
    $(document).on("click", ".quantity .plus", function() {
        var wrapper = $(this).parent();
      try {
          wrapper.find('input[type=number]').get(0).stepUp();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())+1);
          wrapper.find('input[type=number]').val(value);
          wrapper.find('input[type=number]').change();
        }
    });

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}

  	
  		$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });
  	

  	$(window).scroll(function(){
      if($(this).scrollTop()<=200) {
        $('.scrollup').fadeOut();
      } else {
        $('.scrollup').fadeIn();
      }

      
    });
  $(".scroll-to, #product-info .description a[href='#more-info']").on("click", function(event){
    var targetElement = $(this).attr('href');
    event.preventDefault();
    if($(targetElement).closest('.scrollable').length && !isMobile.any){
      //$("html, body").animate({ scrollTop: $(targetElement).closest('.scrollable').offset().top - $('#header').height() }, 500, function(){
      //$(targetElement).closest('.scrollable')[0].scrollTop = $(targetElement).position().top;
      
      /* Removing this because apparently the scrollable columns were removed */
      //var scrollTo = $(targetElement).position().top + $(targetElement).closest('.scrollable').scrollTop()/* - $('#header').height()*/;
      //$(targetElement).closest('.scrollable').animate({ scrollTop: scrollTo }, 500);
      /* Removing this because apparently the scrollable columns were removed */
      
      $("html, body").animate({ scrollTop: $(targetElement).offset().top - $('#header').height() }, 500);
      
      //});
    }else if(isMobile.any){
      if($(targetElement + '-mobile').length > 0){
        $("html, body").animate({ scrollTop: $(targetElement + '-mobile').offset().top - $('.header-internal').height() }, 500);
      }else{
        $("html, body").animate({ scrollTop: $(targetElement).offset().top - $('.header-internal').height() }, 500);
      }
    }else{
      $("html, body").animate({ scrollTop: $(targetElement).offset().top - $('#header').height() }, 500);
    }
  });
    
  $(window).load(function(){
    var hash = location.hash.replace('#','');
    if(hash != ''){
      $('html, body').animate({ scrollTop: $('#'+hash).offset().top - $('#header').height() }, 500);
    }
  });

  setupDropdownMenus();  
  
  menuMobile();
  
});

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
	$('.isNotMobile .main-menu .has-dropdown').hoverIntent( navRollOver, navRollOut );
	function navRollOver(e){
      if($(this).closest('#mega-menu-fullscreen').length > 0 && !$(this).hasClass('active')){
        $(this).closest('#mega-menu-fullscreen').find('.active').removeClass('active').find('.submenu:first').slideUp();
      }
      $(this).addClass('active').find('.submenu:first').slideDown();
	}
	function navRollOut(e){
      if($(this).closest('#mega-menu-fullscreen').length > 0){
      }else{
        $(this).removeClass('active').find('.submenu:first').slideUp();
      }
	}
}

function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
          if($(".product-pot-wrap").length != 0){
            alert("Please select a pot.");
          }else{
            alert("Please select a "+labels.join('/')+".");
          }
        }
      	return false;
    }else{
      if(form.find('.product-pots .thumbs-swatches-wrap .thumb').length > 1 && form.find('.product-pots .thumbs-swatches-wrap .thumb.active').length == 0){
        alert("Please select a pot.");
        return false;
      }
    }
  	return true;
}

function initSideCart() {
	$('.header .cart-wrap').click(function(e){
      e.stopPropagation();
      showSideCart(true);
      return false;
    });

    $(document).click(function(event){
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
        hideSideCart();
      }
    });
}

/**
 * Ajax add-to-cart
 */
var potId = false;
var feeId = false;
var saucerId = false;

function addToCart(form){
	
  	if(modal) modal.close();
  
    potId = $('#pot-id').val();
    if($("#product-wrap").find('input.pot-selector').is(':checked')){
      feeId = $('#potting-fee-id').val();
    }else{
      feeId = false;
    }

    if($("#product-wrap").find('input.saucer-selector').is(':checked')){
      saucerId = $('#saucer-id').val();
    }else{
      saucerId = false;
    }
  
    var formData = getFormData(form);

    var prodsToAdd = [];
    prodsToAdd.push(formData);

    if(potId != "" && $(".product-pot-wrap").length == 0 && $(".product-gift-card").length == 0){
      prodsToAdd.push({ id : $("#pot-id").val(), quantity : $("#quantity").val(), properties: {'combo-id': $("#product-combo-id").val()} })
      if(feeId){
        prodsToAdd.push({ id : feeId, quantity : $("#quantity").val(), properties: {'combo-id': $("#product-combo-id").val()} });
      }
    }
    if(saucerId){
      prodsToAdd.push({ id : saucerId, quantity : $("#quantity").val(), properties: {'combo-id': $("#product-combo-id").val()} });
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items : prodsToAdd },
      dataType: 'json',
      error: addToCartFail,
      success: function(data){
        feeId = false;
        potId = false;
        saucerId = false;

        addedToCartPopup();
      },
      cache: false
    });
  
}

function getFormData($form){
  var unindexed_array = $form.serializeArray();
  var indexed_array = {};

  $.map(unindexed_array, function(n, i){
    indexed_array[n['name']] = n['value'];
  });

  return indexed_array;
}
/*
function addToCartSuccess(jqXHR, textStatus, errorThrown){
  //updateCartDesc();
  if(potId != "" && $(".product-pot-wrap").length == 0 && $(".product-gift-card").length == 0){
    
    var prodsToAdd = [];
    prodsToAdd.push({ id : $("#pot-id").val(), quantity : $("#quantity").val(), properties: {'combo-id': $("#product-combo-id").val()} })

    if(feeId){
      prodsToAdd.push({ id : feeId, quantity : $("#quantity").val(), properties: {'combo-id': $("#product-combo-id").val()} });
    }
    if(saucerId){
      prodsToAdd.push({ id : saucerId, quantity : $("#quantity").val(), properties: {'combo-id': $("#product-combo-id").val()} });
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items : prodsToAdd },
      dataType: 'json',
      error: addToCartFail,
      success: function(data){
        feeId = false;
        potId = false;
        saucerId = false;
        
        addedToCartPopup();
      },
      cache: false
    });
    
  }else{
    addedToCartPopup();
  }
}*/

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#loading-overlay').hide();
  	modal = new tingle.modal({
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: "Close",
        cssClass: ['message']
      });
    modal.setContent('<div class="error-itemincart">'+response.description+'</div>');
    modal.open();
}

function addedToCartPopup(){
  
	modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      onOpen:function(){
      	$('.recommended-products .product-carousel').slick({
          autoplay: true,
          speed: 1000,
          slidesToShow: 3,
          pauseOnHover: false,
          slidesToScroll: 3,
          prevArrow: '<i class="lnr lnr-chevron-left left-arrow animation"></i>',
          nextArrow: '<i class="lnr lnr-chevron-right right-arrow animation"></i>',
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
          ]
        });
      }
    });
  	
    modal.setContent($('#productAddedPopup'));
    modal.open();
}

function updateCartDesc(){
  	window.location = "/cart";
  	/*$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          	$('#loading-overlay').hide();
          
      		var animate = true;
          	if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
              	animate = false;
            }
          	$('#side-cart').remove();
          	$('#page').append(data);
          	if(modal) modal.close();
          	showSideCart(animate);
      	}
	});*/
}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
  }
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
}

function randomstring(L){
    var s= '';
    var randomchar=function(){
    	var n= Math.floor(Math.random()*62);
    	if(n<10) return n; //1-10
    	if(n<36) return String.fromCharCode(n+55); //A-Z
    	return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
}

function getQueryParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function openModal(content) {
	modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close"
    });
    modal.setContent(content);
    modal.open();
}

function menuMobile(){
  $("#menu-mobile-button").click(function(event){
    event.preventDefault();
    $("#header .main-menu-container").addClass('opened');
    $("#header .close-main-menu").css("display", "block");
    $('#page').addClass('mode-overlay-white');
    $('body, html').css({overflow: 'hidden'});
  });
  
  if($(".isMobile #header .main-menu").find('li.active').length == 0){
    $("#header .main-menu > ul > li").first().addClass('active');
  }
  
  $(".isMobile #header .main-menu > ul > li > div > a").click(function(event){
    event.preventDefault();
    
    $("#header .main-menu li.active").removeClass('active')
    $(this).closest('li').addClass('active');
    
    $('.submenu').hide();
    $(this).parent().find('.submenu').show();
    return false;
  });
  
  $("#header .close-main-menu").click(function(event){
    event.preventDefault();
    $("#header .close-main-menu").css("display", "none");
    $('#page').removeClass('mode-overlay-white');
    $("#header .main-menu-container").removeClass('opened');
    
    $('body, html').css({overflow: ''});
  });
}